var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.queryid === undefined || _vm.queryid === "")?_c('Dataset'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }